<template>
  <transition>
    <header ref="header">
      <router-link class="home" to="/">
        <p>Home</p>
      </router-link>
      <router-link class="about" to="about">
        <p>about</p>
      </router-link>
    </header>
  </transition>
</template>

<script>
export default {
  name: "Drone"
};
</script>

<style scoped lang="scss">
header {
  position: fixed;
  z-index: 21;
  font-size: 1.5rem;
  pointer-events: none;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  color: $lightSecondary;
  a {
    pointer-events: all;
    transition: opacity 0.5s ease;
    opacity: 0.5;
    mix-blend-mode: difference;
    &:hover {
      opacity: 1;
    }
    @include bigScreen {
      margin: 3rem;
    }
  }

  .home {
    position: absolute;
    left: 0.5vw;
    top: 1vw;
    writing-mode: vertical-lr;
  }
  .about {
    position: absolute;
    bottom: 1vw;
    right: 0.5vw;
  }
}
.router-link-exact-active {
  opacity: 1;
}
</style>
